export const LOGIN_FORM_PHONE_NOTIFICATION_GET_CAPTCHA_ERROR = 'captcha_error'

export const LOGIN_FORM_PHONE_CAPTCHA_TOKEN = 'captcha_token'

export const LOGIN_FORM_PHONE_NUMBER_SERVER_ERROR_INVALID_CAPTCHA =
  'Captcha_verification_failed'

export const LOGIN_FORM_PHONE_NUMBER_SERVER_ERROR_ONLY_DWELLER_CAN_LOGIN =
  'Only_dweller_can_login_to_mobile_app'

export const LOGIN_FORM_PHONE_NUMBER_SERVER_NON_FIELD_ERRORS = {
  [LOGIN_FORM_PHONE_NUMBER_SERVER_ERROR_INVALID_CAPTCHA]:
    'Error.CaptchaVerificationFailedKey',
  [LOGIN_FORM_PHONE_NUMBER_SERVER_ERROR_ONLY_DWELLER_CAN_LOGIN]:
    'Error.OnlyDwellerCanLoginViaPhoneKey',
}

export const LOGIN_FORM_PHONE_VERIFICATION_SERVER_ERROR_CODES_DO_NOT_MATCH =
  'Codes_do_not_match'

export const LOGIN_FORM_PHONE_VERIFICATION_SERVER_NON_FIELD_ERRORS = {
  [LOGIN_FORM_PHONE_VERIFICATION_SERVER_ERROR_CODES_DO_NOT_MATCH]:
    'Error.PhoneVerificationCodesDoNotMatchKey',
}
